// es-ES only groups thousands from 5 digits by default ("6709" next to "41.208");
// counts always use the thousands separator so figures line up.
// The ES2022 lib types still declare useGrouping as boolean, hence the cast.
export const COUNT_FORMAT = { useGrouping: "always" } as unknown as Intl.NumberFormatOptions;

const countFormatter = new Intl.NumberFormat("es-ES", COUNT_FORMAT);

export function formatCount(value: number): string {
  return countFormatter.format(value);
}
